'use strict';

var _ = require('lodash');
var AppNavigationController = function AppNavigationController($scope, userSecureService, bootstrapFeaturesService) {
  $scope.navigationItems = {
    foDashboard: false,
    dashboard: false,
    marketAnalysis: false,
    flightAnalysis: false,
    fares: false,
    romAnalysis: false,
    romSummary: false,
    rules: false,
    strategies: false,
    dataExtract: false,
    scheduleChange: false,
    seasonality: false,
    calibrationAnalysis: false,
    systemStatus: false,
    systemConfiguration: false,
    userManagement: false,
    pricingSummary: false,
    pricingAnalysis: false,
    faresOptimizerAnalysis: false,
    userExclusions: false
  };
  function checkPermissions() {
    var elementsToAuthorize = getComponentsToAuthorize($scope.navigationItems);
    var authorizedElements = userSecureService.getPermissions(elementsToAuthorize);
    var privileges = _.reduce(authorizedElements, function (privileges, authorized, resource) {
      privileges[_.camelCase(resource)] = authorized;
      return privileges;
    }, {});
    _.extend($scope.navigationItems, privileges);
  }
  function getComponentsToAuthorize(items) {
    return _.map(_.keys(items), _.kebabCase);
  }
  $scope.isMultipleAppsSelected = function () {
    return bootstrapFeaturesService.getEnabledApps().length > 1;
  };
  checkPermissions();
};
AppNavigationController.$inject = ['$scope', 'UserSecureService', 'BootstrapFeaturesService'];
module.exports = AppNavigationController;